// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-t9Hgd {
  background-color: #ff7f50;
}
.debug2-JsNNc {
  background-color: #6495ed;
}
.vtprices-smhQ2 {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 8px 20px;
  background-color: #FFFFFF;
  border-radius: 20px;
  color: #5D5D5D;
  cursor: pointer;
}
.vtprices-smhQ2 .text-osdQP {
  width: 100%;
  font-size: 1.125em;
  font-family: "AvenirBlack";
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.vtprices-smhQ2 .icon-exTdt {
  vertical-align: middle;
  margin-right: 15px;
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 {
  position: absolute;
  top: 30px;
  width: auto;
  padding: 20px;
  margin-right: 5px;
  background-color: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #dcdfe4;
  box-shadow: 0 0 8px #00000040;
  font-size: 1em;
  font-family: "AvenirBlack";
  text-align: left;
  z-index: 999;
  cursor: default;
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 .price-sDpdj {
  display: flex;
  gap: 10px;
  width: 100%;
  height: 60px;
  margin-bottom: 5px;
  border-bottom: 1px solid #E1E1E1;
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 .price-sDpdj .name-knSMF {
  flex: 1;
  height: 60px;
  line-height: 60px;
  margin-left: 15px;
  font-size: 1.125em;
  font-family: "AvenirBlack";
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 .price-sDpdj .controls-yDRn_ {
  display: flex;
  align-items: center;
  width: 100px;
  height: 60px;
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 .price-sDpdj .controls-yDRn_ .persons-yPRZG {
  width: 30px;
  height: 30px;
  margin-inline: 10px;
  line-height: 14px;
  color: #333333;
  text-align: center;
  border: 1px solid #E1E1E1;
  font-size: 0.9375em;
  font-family: "AvenirBlack";
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 .price-sDpdj .controls-yDRn_ .buttons-akja2 {
  width: 22px;
  line-height: 19px;
  border-radius: 11px;
  border: 2px solid #33CCFF;
  text-align: center;
  cursor: pointer;
  color: #33CCFF;
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 .price-sDpdj .controls-yDRn_ .buttonMinus-XewVC {
  width: 22px;
  line-height: 19px;
  border-radius: 11px;
  border: 2px solid #33CCFF;
  text-align: center;
  cursor: pointer;
  color: #33CCFF;
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 .price-sDpdj .controls-yDRn_ .buttonPlus-_5dKw {
  width: 22px;
  line-height: 19px;
  border-radius: 11px;
  border: 2px solid #33CCFF;
  text-align: center;
  cursor: pointer;
  color: #33CCFF;
}
.vtprices-smhQ2 .pricesmodal-cH1Q2 .price-sDpdj:last-child {
  border: 0;
}
@media only screen and (max-width: 800px) {
  .vtprices-smhQ2 .pricesmodal-cH1Q2 {
    left: -200px;
    width: auto;
  }
}
@media only screen and (max-width: 535px) {
  .vtprices-smhQ2 .pricesmodal-cH1Q2 {
    left: -20px;
    width: 100%;
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VTForm/components/VTPrices/VTPrices.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAU,kBAAA;EAAmB,sBAAA;EAAwB,WAAA;EAAa,iBAAA;EAAkB,yBAAA;EAA0B,mBAAA;EAAsB,cAAA;EAAmB,eAAA;AAyCvJ;AAzCA;EACQ,WAAA;ECqCN,kBAAA;EDrCmC,0BAAA;EAA2B,uBAAA;EAAyB,gBAAA;EAAkB,mBAAA;AAgD3G;AAjDA;EAEQ,sBAAA;EAAwB,kBAAA;AAmDhC;AArDA;EAGe,kBAAA;EAAmB,SAAA;EAAU,WAAA;EAAY,aAAA;EAAc,iBAAA;EAAmB,yBAAA;EAA0B,kBAAA;EAAoB,yBAAA;EAA2B,6BAAA;ECmChK,cAAA;EDnC+M,0BAAA;EAA2B,gBAAA;EAAiB,YAAA;EAAc,eAAA;AAkE3Q;AArEA;EAIW,aAAA;EAAc,SAAA;EAAU,WAAA;EAAY,YAAA;EAAc,kBAAA;EAAoB,gCAAA;AAyEjF;AA7EA;EAKY,OAAA;EAAQ,YAAA;EAAc,iBAAA;EAAmB,iBAAA;ECiCnD,kBAAA;EDjCsF,0BAAA;EAA2B,mBAAA;EAAqB,uBAAA;EAAyB,gBAAA;AAmFjK;AAxFA;EAMgB,aAAA;EAAc,mBAAA;EAAoB,YAAA;EAAa,YAAA;AAwF/D;AA9FA;EAOiB,WAAA;EAAY,YAAA;EAAa,mBAAA;EAAoB,iBAAA;EAAkB,cAAA;EAAmB,kBAAA;EAAoB,yBAAA;EC+BrH,mBAAA;ED/BoK,0BAAA;AAkGtK;AAzGA;EAQiB,WAAA;EAAY,iBAAA;EAAkB,mBAAA;EAAqB,yBAAA;EAA8B,kBAAA;EAAmB,eAAA;EAAgB,cAAA;AA0GrI;AAlHA;EAQiB,WAAA;EAAY,iBAAA;EAAkB,mBAAA;EAAqB,yBAAA;EAA8B,kBAAA;EAAmB,eAAA;EAAgB,cAAA;AAmHrI;AA3HA;EAQiB,WAAA;EAAY,iBAAA;EAAkB,mBAAA;EAAqB,yBAAA;EAA8B,kBAAA;EAAmB,eAAA;EAAgB,cAAA;AA4HrI;AApIA;EAasB,SAAA;AA0HtB;AAtHA;EACE;IACe,YAAA;IAAa,WAAA;EAyH5B;AACF;AApHA;EACE;IACe,WAAA;IAAY,WAAA;IAAY,aAAA;EAwHvC;AACF","sourcesContent":["@import \"../../../../assets/css/theme\";\n\n.vtprices{position:relative; box-sizing: border-box; width: 100%; padding:8px 20px; background-color:#FFFFFF; border-radius: 20px;  color:@colorgris5; cursor:pointer;\n  .text{width: 100%; .font-base(18); font-family:\"AvenirBlack\"; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;}\n  .icon{vertical-align: middle; margin-right: 15px;}\n  .pricesmodal{position:absolute; top:30px; width:auto; padding:20px; margin-right: 5px; background-color:#FFFFFF; border-radius: 6px; border: 1px solid #dcdfe4; box-shadow: 0 0 8px #00000040; .font-base(16); font-family:\"AvenirBlack\"; text-align:left; z-index: 999; cursor:default;\n    .price{display:flex; gap:10px; width:100%; height: 60px; margin-bottom: 5px; border-bottom: 1px solid @colorgris1;\n      .name{flex:1; height: 60px; line-height: 60px; margin-left: 15px; .font-base(18); font-family:\"AvenirBlack\"; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;}\n      .controls{display:flex; align-items:center; width:100px; height: 60px;\n        .persons{width:30px; height:30px; margin-inline:10px; line-height:14px; color:@colorgris4; text-align: center; border: 1px solid @colorgris1; .font-base(15); font-family:\"AvenirBlack\";}\n        .buttons{width:22px; line-height:19px; border-radius: 11px; border:2px solid @colorazul1; text-align:center; cursor:pointer; color:@colorazul1;}\n        .buttonMinus{.buttons;}\n        .buttonPlus{.buttons;}\n      }\n    }\n    .price:last-child{border:0;}\n  }\n}\n\n@media only screen and (max-width : 800px) {\n  .vtprices{\n    .pricesmodal{left:-200px; width:auto;\n\n    }\n  }\n}\n\n@media only screen and (max-width : 535px) {\n  .vtprices{\n    .pricesmodal{left:-20px; width:100%; padding:20px;\n\n    }\n  }\n}\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-t9Hgd`,
	"debug2": `debug2-JsNNc`,
	"vtprices": `vtprices-smhQ2`,
	"text": `text-osdQP`,
	"icon": `icon-exTdt`,
	"pricesmodal": `pricesmodal-cH1Q2`,
	"price": `price-sDpdj`,
	"name": `name-knSMF`,
	"controls": `controls-yDRn_`,
	"persons": `persons-yPRZG`,
	"buttons": `buttons-akja2`,
	"buttonMinus": `buttonMinus-XewVC`,
	"buttonPlus": `buttonPlus-_5dKw`
};
export default ___CSS_LOADER_EXPORT___;
